<template>
  <component
    :is="linkUrl ? 'a' : 'div'"
    :href="linkUrl"
    :class="{ loaded: loaded }"
    class="epi-picture"
  >
    <div
      v-if="!url || failed"
      class="empty-image-placeholder"
    >
      <svgicon
        name="Misc/EmptyPlaceholder"
        class="empty-image-placeholder__icon"
      />
    </div>
    <picture
      v-else-if="usePicture && loaded"
    >
      <source
        :srcset="getCloudinaryUrl(sizeSettings.small)"
        media="(max-width: 48em)"
      >
      <source
        :srcset="getCloudinaryUrl(sizeSettings.medium)"
        media="(max-width: 64em)"
      >
      <img
        :src="getCloudinaryUrl(sizeSettings.large)"
        :alt="alt || ''"
      >
    </picture>
    <div
      v-else
      :class="currentSize"
      :style="backgroundImageStyle"
      class="epi-background-container"
      :role="alt ? 'img' : null"
      :aria-label="alt"
    />
    <img
      v-if="!loaded"
      ref="lazyLoadImage"
      class="lazy-load-image"
      alt=""
      @load="lazyLoadComplete"
      @error="lazyLoadFailed"
    >
  </component>
</template>

<script>
import commonPictureConfig from './commonPictureConfig'
import '#/Misc/EmptyPlaceholder'
export default {
  mixins: [commonPictureConfig],
  props: {
    alt: {
      type: String,
      default: ''
    },
    aspectRatio: {
      type: Number,
      default: 100
    },
    url: {
      type: String,
      default: null
    },
    linkUrl: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      failed: false,
      loaded: false,
      watcher: null
    }
  },
  computed: {
    backgroundImageStyle () {
      let ar = `padding-bottom:${this.aspectRatio}%;`
      let backgroundImage = this.loaded ? `background-image:url("${this.currentImageUrl}");` : ''

      return `${backgroundImage}${ar}`
    },
    currentImageUrl () {
      return this.getCloudinaryUrl(this.sizeSettings[this.currentSize])
    },
    hasImage () {
      return !!this.url
    }
  },
  watch: {
    url () {
      if (this.hasImage) {
        this.loaded = false
        this.failed = false
        this.$nextTick(() => {
          this.createScrollmonitor()
        })
      }
    }
  },
  methods: {
    getCloudinaryUrl (dimension) {
      if (!this.url) {
        return
      }

      // If a named tranformation is used add it to url and return it.
      if (this.namedTransformations) {
        return `${this.$root.envConfig.cloudinaryBaseUrl}/${this.namedTransformations[[this.currentSize]]}${this.url}`
      }

      let scaleParams = ''
      if (dimension.ar && dimension.width) {
        scaleParams = `w_${dimension.width},ar_${dimension.ar},c_fill`
      } else if (dimension.height && dimension.width) {
        scaleParams = `w_${dimension.width},h_${dimension.height},c_lfill`
      } else if (dimension.width) {
        scaleParams = `w_${dimension.width},c_scale`
      } else if (dimension.height) {
        scaleParams = `h_${dimension.height},c_scale`
      }
      return `${this.$root.envConfig.cloudinaryBaseUrl}/image/upload/${scaleParams}${this.sharpenParam}/f_auto,${this.qualityParam},${this.dprParam}/${this.url}`
    }
  },
}
</script>

<style lang="scss">
  @import './commonPictureStyles.scss';
</style>

